const DEFAULT_PARENT_BINDING_DETAIL_URL = '/user-info?tab=parent-binding'
const PARENT_BINDING_MSG_TYPE_ID = 20

const RELATION_MAP = {
  1: '爸爸',
  2: '妈妈',
  3: '其他',
}

function getRelationText(relation) {
  return RELATION_MAP[relation] || '其他'
}

function getParentBindingDetailUrl() {
  return DEFAULT_PARENT_BINDING_DETAIL_URL
}

function isParentBindingNotice(item = {}) {
  return Number(item.msg_type_id) === PARENT_BINDING_MSG_TYPE_ID || item.msg_type_name === '家长绑定'
}

function getBindingNoticeTag(item = {}) {
  const content = item.content || ''
  const match = content.match(/^(爸爸|妈妈|其他)/)
  return match ? match[1] : '家长绑定'
}

function buildBindingNoticeCard(requests = []) {
  if (!Array.isArray(requests) || requests.length === 0) {
    return null
  }

  const tags = requests
    .map((item) => item.parent_nickname || getRelationText(item.relation))
    .filter(Boolean)
    .slice(0, 3)

  const count = requests.length
  const firstRequest = requests[0] || {}

  return {
    title: '待确认的绑定申请',
    description: `当前有 ${count} 条家长绑定申请待处理，请前往家长绑定页查看详情并完成确认。`,
    ctaText: '查看详情',
    href: getParentBindingDetailUrl(),
    tags,
    createdAt: firstRequest.created_at || 0,
  }
}

module.exports = {
  buildBindingNoticeCard,
  getBindingNoticeTag,
  getParentBindingDetailUrl,
  getRelationText,
  isParentBindingNotice,
}
